import styles from './CreateInviteSuccess.module.css';

/**
 * CreateInviteSuccess Component
 *
 * Success message with invite code after creation
 */
function CreateInviteSuccess({ createdCode, copyToClipboard, handleDone }) {
    return (
        <>
            <div className={styles.successContainer}>
                <p className={styles.successMessage}>Invite code created successfully!</p>
                <div className={styles.inviteCode}>
                    {createdCode}
                </div>
                <button
                    onClick={copyToClipboard}
                    className={styles.copyButton}
                >
                    Copy to Clipboard
                </button>
            </div>

            <div className={styles.warningContainer}>
                <strong className={styles.warningStrong}>Share this code with the person you want to invite.</strong><br />
                They can enter it on the Invites page to gain access to your budget.
            </div>

            <div className={styles.buttonContainer}>
                <button
                    onClick={handleDone}
                    className={styles.doneButton}
                >
                    Done
                </button>
            </div>
        </>
    );
}

export default CreateInviteSuccess;
